// Browser entry for /login and /signup — bundled separately by
// scripts/bundleAppClient.ts (esbuild) and served static at
// /app-assets/auth-client.js. Hydrates the exact tree authServer.ts
// prerendered. No initial data to read back: neither page's first paint
// depends on per-visitor data (see LoginPage.ts / SignupPage.ts).
import { h } from 'preact';
import hydrate from 'preact-iso/hydrate';
import { AuthRoot } from './auth/AuthRoot.js';

const rootProps: Record<string, unknown> = {};
hydrate(h(AuthRoot, rootProps));
